export const MATCH_SIMILARITY_THRESHOLD = 0.8

const normalizeTitle = title => (title || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

const levenshteinDistance = (a, b) => {
    const rows = a.length + 1
    const cols = b.length + 1
    const matrix = []

    for (let i = 0; i < rows; i++) {
        matrix.push([i])
    }

    for (let j = 1; j < cols; j++) {
        matrix[0][j] = j
    }

    for (let i = 1; i < rows; i++) {
        for (let j = 1; j < cols; j++) {
            matrix[i][j] = a[i - 1] === b[j - 1]
                ? matrix[i - 1][j - 1]
                : 1 + Math.min(matrix[i - 1][j - 1], matrix[i - 1][j], matrix[i][j - 1])
        }
    }

    return matrix[rows - 1][cols - 1]
}

const titleSimilarity = (titleA, titleB) => {
    const normalizedA = normalizeTitle(titleA)
    const normalizedB = normalizeTitle(titleB)
    const maxLength = Math.max(normalizedA.length, normalizedB.length)

    if (0 === maxLength) {
        return 0
    }

    return 1 - (levenshteinDistance(normalizedA, normalizedB) / maxLength)
}

const isUnmatchedPreviewMovie = (previewMovie, movieMappingsItems) => {
    const mapping = movieMappingsItems[previewMovie.metaMoviePk]
    return !mapping || !mapping.source || 0 === mapping.source.length
}

const getFetchedMovies = fetchReport => (fetchReport && Array.isArray(fetchReport.reports) ? fetchReport.reports : []).flatMap(
    report => (Array.isArray(report.movie_details) ? report.movie_details : [])
        .filter(detail => 'included' === detail.status)
        .map(detail => ({
            title: detail.title,
            metaMoviePk: detail.meta_movie_pk,
            provider: report.provider,
        }))
)

const getMatchCandidates = (fetchReport, previewMovieItems, movieMappingsItems) => {
    const fetchedMovies = getFetchedMovies(fetchReport)
    const previewMovies = Object.values(previewMovieItems || {}).filter(
        previewMovie => isUnmatchedPreviewMovie(previewMovie, movieMappingsItems || {})
    )

    return previewMovies.reduce((candidates, previewMovie) => {
        const bestMatch = fetchedMovies.reduce((best, fetchedMovie) => {
            const similarity = titleSimilarity(previewMovie.title, fetchedMovie.title)
            return similarity > (best ? best.similarity : 0) ? { fetchedMovie, similarity } : best
        }, null)

        if (bestMatch && bestMatch.similarity >= MATCH_SIMILARITY_THRESHOLD) {
            candidates.push({ previewMovie, fetchedMovie: bestMatch.fetchedMovie, similarity: bestMatch.similarity })
        }

        return candidates
    }, [])
}

export default getMatchCandidates
